import { render } from "./ExtensionWhitelist.vue?vue&type=template&id=4dbf1318&scoped=true"
import script from "./ExtensionWhitelist.vue?vue&type=script&lang=js"
export * from "./ExtensionWhitelist.vue?vue&type=script&lang=js"

import "./ExtensionWhitelist.vue?vue&type=style&index=0&id=4dbf1318&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbf1318"]])

export default __exports__